import React, { useContext, useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import SessionContext from '@providers/Session/SessionContext';
import useSwr from '@hooks/useSwr';
import { AlarmGraphAppNameOptions } from '@utils/alarmsConstants';

interface TransactionHistoryFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function TransactionHistoryField({
  options,
  loading,
  disabled = false,
}: TransactionHistoryFieldProps) {
  const { t } = useTranslation('create-alarm-step');
  const { customer } = useContext(SessionContext);
  const customerId = customer?.customerLogged?.id;
  const [selectedSite, setSelectedSite] = useState<string | undefined>();
  const form = Form.useFormInstance();

  const { data: statusData } = useSwr<{
    data?: string[];
  }>(
    customerId && selectedSite
      ? `/service-proxy/dashboard/transacao/alarme/kapacitor/alerta_task/listar_transacao_site?site=${selectedSite}&customerId=${customerId}&tipoGrafico=${AlarmGraphAppNameOptions.APPNAME_TRANSACTION_HISTORY}`
      : null,
    {
      headers: {
        customerId,
        site: selectedSite,
        tipoGrafico: AlarmGraphAppNameOptions.APPNAME_TRANSACTION_HISTORY,
      },
    },
  );

  useEffect(() => {
    if (selectedSite) {
      form.setFieldValue('transactionHistoryStatus', undefined);
    }
  }, [selectedSite, form]);

  useEffect(() => {
    const formValue = form.getFieldValue('TransactionHistory');
    if (formValue && !selectedSite) {
      setSelectedSite(formValue);
    }
  }, [form, selectedSite]);

  const statusOptions = Array.isArray(statusData)
    ? statusData.map(item => ({ label: item, value: item }))
    : (statusData?.data || []).map(item => ({ label: item, value: item }));

  return (
    <>
      <Form.Item
        name="TransactionHistory"
        label={t(
          'create-alarm-step:stepOne.createAlarmTransactionsHistoryField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepOne.createAlarmTransactionsHistoryRequired',
            ),
          },
        ]}
      >
        <Select
          allowClear
          options={options}
          loading={loading}
          disabled={loading || disabled}
          style={{ textAlign: 'left' }}
          onChange={value => {
            setSelectedSite(value);
            form.setFieldValue('transactionHistoryStatus', undefined);
          }}
        />
      </Form.Item>

      {selectedSite && (
        <Form.Item
          name="transactionHistoryStatus"
          label={t('create-alarm-step:stepOne.createAlarmAppNameField')}
          rules={[
            {
              required: true,
              message: t(
                'create-alarm-step:stepOne.createAlarmAppNameFieldRequired',
              ),
            },
          ]}
        >
          <Select
            allowClear
            options={statusOptions}
            loading={!statusData}
            disabled={!statusData}
            style={{ textAlign: 'left' }}
          />
        </Form.Item>
      )}
    </>
  );
}
